import { render, staticRenderFns } from "./temp-selected-refer.vue?vue&type=template&id=14ecd2b1&scoped=true"
import script from "./temp-selected-refer.vue?vue&type=script&lang=js"
export * from "./temp-selected-refer.vue?vue&type=script&lang=js"
import style0 from "./temp-selected-refer.vue?vue&type=style&index=0&id=14ecd2b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ecd2b1",
  null
  
)

export default component.exports